import React from 'react';
import Text from './Text';
import { isWebView } from '@lib/webView';

export default class PageTitle extends React.PureComponent {
  render() {
    const { children, textStyle = 'displaySmall', ...props } = this.props;
    const webView = isWebView();

    return (
      <Text
        as="h1"
        fontWeight="bold"
        pt={6}
        pb={webView ? 0 : 6}
        data-testid="page-title"
        textStyle={textStyle}
        {...props}
      >
        {webView ? '' : children}
      </Text>
    );
  }
}
